import styled from "styled-components";

export const StyledNewAssetButtonWrapper = styled.div`
    margin-right: 4px;
`;
